var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMainSearchIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 16,
    viewBox: "0 0 18 18",
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#000"
    },
    id: "a",
    d: "m7.26008345 0c-4.00556328 0-7.26008345 3.25-7.26008345 7.25s3.25452017 7.25 7.26008345 7.25c1.72739916 0 3.32962445-.6 4.55632825-1.625l4.906815 4.9c.3004172.3.7760779.3 1.0514604 0 .3004172-.3.3004172-.75 0-1.05l-4.9068151-4.9c1.0264256-1.25 1.6272601-2.85 1.6272601-4.575.0250348-4-3.2294854-7.25-7.23504865-7.25zm0 1.5c3.17941585 0 5.75799725 2.575 5.75799725 5.75s-2.5785814 5.75-5.75799725 5.75c-3.17941586 0-5.75799722-2.575-5.75799722-5.75 0-3.2 2.57858136-5.75 5.75799722-5.75z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainSearchIcon);
export default __webpack_public_path__ + "static/media/main_search_icon.ced607f445f037ae6de243c795901ef8.svg";
export { ForwardRef as ReactComponent };